<template>
  <div class="myContract">
    <my-contract-tabs>
      <template v-slot:headerLeft>
        <OrderContract />
      </template>
      <template v-slot:headerRight>
        <OtherContract />
      </template>
    </my-contract-tabs>
  </div>
</template>

<script>
import MyContractTabs from './components/myContractTabs.vue';
import OrderContract from './components/orderContract.vue';
import OtherContract from './components/otherContract.vue';

export default {
  name: 'myContract',
  components: {
    MyContractTabs,
    OrderContract,
    OtherContract,
  },
  data() {
    return {
    };
  },
};
</script>
<style scoped>
</style>
